import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-testimonial-card',
  standalone: true,
  templateUrl: './testimonial-card.component.html',
  styleUrl: './testimonial-card.component.css'
})
export class TestimonialCardComponent {
  @Input() imageSrc = '';
  @Input() imageAlt = 'Client testimonial image';
  @Input() title = '';
  @Input() quote = '';
  @Input() name = '';
  @Input() role = '';
}
